import React from "react";
import { Icon } from "../core/Icon";

export function LanguageToggle({ value = "en", onChange, inverse = false }) {
  const langs = [{ code: "en", label: "EN" }, { code: "es", label: "ES" }];
  return (
    <div role="group" aria-label="Language" style={{
      display: "inline-flex", alignItems: "center", gap: 2, padding: 3,
      borderRadius: "var(--radius-sm)",
      background: inverse ? "var(--cream-a10)" : "var(--surface-muted)",
    }}>
      <Icon name="globe" size={14} style={{ margin: "0 4px", color: inverse ? "var(--cream-a60)" : "var(--text-muted)" }} />
      {langs.map((l) => {
        const on = value === l.code;
        return (
          <button key={l.code} onClick={() => onChange?.(l.code)} style={{
            border: "none", cursor: "pointer", padding: "4px 10px",
            borderRadius: 6, fontFamily: "var(--font-display)",
            fontSize: "var(--text-xs)", fontWeight: "var(--weight-semibold)",
            letterSpacing: "var(--tracking-wide)",
            background: on ? (inverse ? "var(--hive)" : "var(--paper)") : "transparent",
            color: on ? "var(--text-on-primary)" : inverse ? "var(--text-inverse)" : "var(--text-muted)",
            boxShadow: on ? "var(--shadow-soft)" : "none",
            transition: "background-color var(--duration-base) var(--ease-out)",
          }}>{l.label}</button>
        );
      })}
    </div>
  );
}
